import { showAlert } from './alerts';
const blogEditArticle = document.querySelector('.blogEditArticle');
const blogAdmin = document.querySelector('.blogAdmin');

if (blogAdmin) {
  document.addEventListener('DOMContentLoaded', function () {
    const deleteButtons = document.querySelectorAll('button[data-blog-id]');

    deleteButtons.forEach((btn) => {
      btn.addEventListener('click', async function () {
        const blogId = btn.getAttribute('data-blog-id');
        if (!blogId) {
          showAlert('error', "ID de l'article introuvable.");
          return;
        }

        if (!confirm('Êtes-vous sûr de vouloir supprimer cet article de blog ?')) return;

        try {
          const response = await fetch(`/api/v1/blog/${blogId}`, {
            method: 'DELETE',
          });
          const result = await response.json();
          if (result.status === 'success') {
            showAlert('success', 'Article de blog supprimé avec succès !');
            // Optionnel : recharger la page après un petit délai
            setTimeout(() => window.location.reload(), 1500);
          } else {
            showAlert('error', result.message || 'Erreur lors de la suppression.');
          }
        } catch (error) {
          console.error('Erreur lors de la suppression:', error);
          showAlert('error', 'Erreur de connexion au serveur.');
        }
      });
    });
  });
}

if (blogEditArticle) {
  document.addEventListener('DOMContentLoaded', function () {
    // === Gestion de l'image de couverture ===
    const selectCoverImageBtn = document.getElementById('selectCoverImageBtn');
    const coverImageFileInput = document.getElementById('coverImageFile');
    const coverImagePreview = document.getElementById('coverImagePreview');
    if (selectCoverImageBtn && coverImageFileInput && coverImagePreview) {
      selectCoverImageBtn.addEventListener('click', () => {
        coverImageFileInput.click();
      });
      coverImageFileInput.addEventListener('change', function () {
        if (this.files && this.files[0]) {
          const file = this.files[0];
          const reader = new FileReader();
          reader.onload = (e) => {
            coverImagePreview.src = e.target.result;
            coverImagePreview.style.display = 'block';
          };
          reader.readAsDataURL(file);
        }
      });
    }

    // --- Gestion des Catégories ---
    const categoriesInput = document.getElementById('categories');
    const categoriesList = document.getElementById('categoriesList');
    let categoriesArr = [];

    // Au chargement, récupérer les catégories pré-rendues depuis le DOM (les li)
    if (categoriesList) {
      const prepopulatedItems = categoriesList.querySelectorAll('li.blog__categories--item');
      prepopulatedItems.forEach((li) => {
        // On retire le symbole de suppression "x" et on nettoie l'élément
        const text = li.textContent.replace('x', '').trim();
        if (text) {
          categoriesArr.push(text);
        }
      });
    }

    // Ajout de catégories depuis l'input lors d'un keydown
    if (categoriesInput) {
      categoriesInput.addEventListener('keydown', (event) => {
        if (['Enter', ',', ' '].includes(event.key)) {
          event.preventDefault();
          const cat = categoriesInput.value.trim();
          if (cat && !categoriesArr.includes(cat)) {
            categoriesArr.push(cat);
            updateCategoriesUI();
          }
          // Laisser l'input vide (ne pas le remplir avec la liste complète)
          categoriesInput.value = '';
        }
      });

      // Lors du blur, ajouter la valeur si présente et non déjà ajoutée
      categoriesInput.addEventListener('blur', () => {
        const cat = categoriesInput.value.trim();
        if (cat && !categoriesArr.includes(cat)) {
          categoriesArr.push(cat);
          updateCategoriesUI();
        }
        // On ne force pas l'affichage dans l'input afin de garder celui-ci vide
        categoriesInput.value = '';
      });
    }

    // Gestion de la suppression d'un élément dans la liste
    if (categoriesList) {
      categoriesList.addEventListener('click', (event) => {
        if (event.target.classList.contains('blog__categories--remove')) {
          const li = event.target.closest('li.blog__categories--item');
          if (li) {
            const text = li.textContent.replace('x', '').trim();
            categoriesArr = categoriesArr.filter((c) => c !== text);
            updateCategoriesUI();
          }
        }
      });
    }

    // Fonction d'update de l'UI des catégories
    function updateCategoriesUI() {
      categoriesList.innerHTML = '';
      if (categoriesArr.length > 0) {
        categoriesList.classList.remove('hidden');
      } else {
        categoriesList.classList.add('hidden');
      }
      categoriesArr.forEach((cat) => {
        const li = document.createElement('li');
        li.className = 'blog__categories--item';
        li.innerHTML = `${cat} <span class="blog__categories--remove">x</span>`;
        categoriesList.appendChild(li);
      });
    }

    // --- Gestion des Tags --- (similaire à celle des catégories)
    const tagsInput = document.getElementById('tags');
    const tagsList = document.getElementById('tagsList');
    let tagsArr = [];

    if (tagsList) {
      const prepopulatedTags = tagsList.querySelectorAll('li.blog__tags--item');
      prepopulatedTags.forEach((li) => {
        const text = li.textContent.replace('x', '').trim();
        if (text) {
          tagsArr.push(text);
        }
      });
    }

    if (tagsInput) {
      tagsInput.addEventListener('keydown', (event) => {
        if (['Enter', ',', ' '].includes(event.key)) {
          event.preventDefault();
          const tag = tagsInput.value.trim();
          if (tag && !tagsArr.includes(tag)) {
            tagsArr.push(tag);
            updateTagsUI();
          }
          tagsInput.value = '';
        }
      });

      tagsInput.addEventListener('blur', () => {
        const tag = tagsInput.value.trim();
        if (tag && !tagsArr.includes(tag)) {
          tagsArr.push(tag);
          updateTagsUI();
        }
        tagsInput.value = '';
      });
    }

    if (tagsList) {
      tagsList.addEventListener('click', (event) => {
        if (event.target.classList.contains('blog__tags--remove')) {
          const li = event.target.closest('li.blog__tags--item');
          if (li) {
            const text = li.textContent.replace('x', '').trim();
            tagsArr = tagsArr.filter((t) => t !== text);
            updateTagsUI();
          }
        }
      });
    }

    function updateTagsUI() {
      tagsList.innerHTML = '';
      if (tagsArr.length > 0) {
        tagsList.classList.remove('hidden');
      } else {
        tagsList.classList.add('hidden');
      }
      tagsArr.forEach((tag) => {
        const li = document.createElement('li');
        li.className = 'blog__tags--item';
        li.innerHTML = `${tag} <span class="blog__tags--remove">x</span>`;
        tagsList.appendChild(li);
      });
    }

    let activeLang = 'fr';

    // === Récupération des éléments du DOM ===
    const languageRadios = document.querySelectorAll('input[name="language"]');
    const titleFrInput = document.getElementById('title');
    const titleEnInput = document.getElementById('titleEN');
    const descFrInput = document.getElementById('description');
    const descEnInput = document.getElementById('descriptionEN');
    const contentHiddenFr = document.getElementById('content-hidden-fr');
    const contentHiddenEn = document.getElementById('content-hidden-en');
    const publicationDateInput = document.getElementById('publicationDate');
    const editBlogForm = document.getElementById('editBlogForm');
    const loaderModal = document.getElementById('modalLoaderDocs');
    const overlay = document.querySelector('.overlay');

    // --- Gestion du sélecteur de langue ---
    const articleDataEl = document.getElementById('articleData');
    const englishData = {
      title: articleDataEl ? articleDataEl.getAttribute('data-title-en') : '',
      description: articleDataEl ? articleDataEl.getAttribute('data-description-en') : '',
      content: articleDataEl ? articleDataEl.getAttribute('data-content-en') : '',
    };

    // === Gestion de l'éditeur Quill ===
    const editorElem = document.getElementById('editor');
    if (!editorElem) {
      console.error("L'élément #editor est introuvable.");
      return;
    }
    const editor = new Quill(editorElem, {
      theme: 'snow',
      modules: {
        toolbar: [
          [{ header: [2, 3, 4, false] }, { font: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ align: [] }],
          ['bold', 'italic', 'underline'],
          ['link', 'image'],
          [{ color: [] }, { background: [] }],
          ['clean'],
        ],
      },
      placeholder: 'Commencez à éditer...',
    });
    window.quill = editor;

    // Récupère le module toolbar
    const toolbar = editor.getModule('toolbar');

    // Remplace le handler image par défaut
    toolbar.addHandler('image', function () {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.click();

      input.onchange = async () => {
        const file = input.files[0];
        if (!file) return;

        // 1) Prompt pour le texte alternatif
        const altText = prompt('Texte alternatif pour cette image ? (laisser vide pour aucun texte)', '');

        // 2) Préparation du FormData pour l'upload
        const formData = new FormData();
        formData.append('image', file);

        try {
          // 3) Envoi au serveur
          const response = await fetch('/api/v1/blog/upload-image', {
            method: 'POST',
            body: formData,
          });
          const result = await response.json();

          if (!result.imageUrl) {
            throw new Error("Pas d'URL retournée");
          }

          // 4) Insertion dans Quill
          const range = editor.getSelection(true);
          editor.insertEmbed(range.index, 'image', result.imageUrl, 'user');

          // 5) Appliquer l'attribut alt sur le <img> inséré
          //    On récupère la feuille (leaf) et on modifie le DOM
          setTimeout(() => {
            const [leaf] = editor.getLeaf(range.index);
            if (leaf && leaf.domNode && altText) {
              leaf.domNode.setAttribute('alt', altText);
            }
          }, 50);
        } catch (err) {
          console.error("Erreur lors de l'upload d'image :", err);
          showAlert('error', "Erreur lors de l'upload de l'image.");
        }
      };
    });

    // Optionnel : double-clic pour modifier l'attribut alt d'une image déjà insérée
    editor.root.addEventListener('dblclick', (e) => {
      const img = e.target.closest('img');
      if (img) {
        const newAlt = prompt('Nouveau texte alternatif :', img.getAttribute('alt') || '');
        if (newAlt !== null) {
          img.setAttribute('alt', newAlt);
        }
      }
    });

    // blogData : objet qui représente toutes les données du blog
    const blogData = {
      title: {
        fr: titleFrInput?.value || '',
        en: titleEnInput?.value || '',
      },
      description: {
        fr: descFrInput?.value || '',
        en: englishData.description || descEnInput?.value || '',
      },
      content: {
        fr: editor.root.innerHTML, // On prend le HTML initial
        en: englishData.content || contentHiddenEn?.value || '',
      },
      createdAt: publicationDateInput?.value || '',
    };

    // --- Gestion du sélecteur de langue (radio buttons) ---
    languageRadios.forEach((radio) => {
      radio.addEventListener('change', function () {
        // Sauvegarder les données pour la langue actuellement active
        if (activeLang === 'fr') {
          blogData.title.fr = titleFrInput.value;
          blogData.description.fr = descFrInput.value;
          blogData.content.fr = editor.root.innerHTML;
        } else {
          blogData.title.en = titleEnInput ? titleEnInput.value : '';
          blogData.description.en = descEnInput ? descEnInput.value : '';
          blogData.content.en = editor.root.innerHTML;
        }

        // Mettre à jour la langue active
        activeLang = this.value;

        // Afficher les champs et le contenu correspondant à la nouvelle langue active
        if (activeLang === 'fr') {
          if (titleFrInput) titleFrInput.style.display = '';
          if (descFrInput) descFrInput.style.display = '';
          if (titleEnInput) titleEnInput.style.display = 'none';
          if (descEnInput) descEnInput.style.display = 'none';
          // Charger le contenu français depuis blogData
          editor.root.innerHTML = blogData.content.fr || '';
        } else {
          if (titleFrInput) titleFrInput.style.display = 'none';
          if (descFrInput) descFrInput.style.display = 'none';
          if (titleEnInput) titleEnInput.style.display = '';
          if (descEnInput) descEnInput.style.display = '';
          titleEnInput.value = blogData.title.en;
          descEnInput.value = blogData.description.en;

          // Charger le contenu anglais depuis blogData
          editor.root.innerHTML = blogData.content.en || '';
        }
      });
    });

    // Quand l'éditeur change, on met à jour blogData.content[activeLang]
    editor.on('text-change', function (delta, oldDelta, source) {
      if (source === 'user') {
        blogData.content[activeLang] = editor.root.innerHTML;
      }
    });

    // --- Traduction du contenu (bouton translateContentBtn) ---
    const translateContentBtn = document.getElementById('translateContentBtn');
    if (translateContentBtn) {
      translateContentBtn.addEventListener('click', async function (e) {
        e.preventDefault();

        // Afficher la modal de chargement
        if (loaderModal) {
          loaderModal.classList.remove('hidden');
          document.body.classList.add('noscroll');
          overlay && overlay.classList.remove('hidden');
        }

        // Récupérer le contenu français depuis blogData
        const contentFr = blogData.content['fr'];
        if (!contentFr) {
          showAlert('error', 'Le contenu en français est vide.');
          if (loaderModal) {
            loaderModal.classList.add('hidden');
            document.body.classList.remove('noscroll');
            overlay && overlay.classList.add('hidden');
          }
          return;
        }

        try {
          const response = await fetch('/api/v1/blog/translate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ contentFr }),
          });
          if (!response.ok) {
            const errorText = await response.text();
            console.error('Erreur serveur lors de la traduction du contenu :', errorText);
            throw new Error('Erreur serveur lors de la traduction du contenu');
          }
          const result = await response.json();
          if (result.status === 'success') {
            // Mise à jour de la version anglaise dans blogData
            blogData.content.en = result.data;
            showAlert('success', 'Contenu traduit en anglais !');
            // Si la langue active est bien l'anglais, mettre à jour l'éditeur
            const activeLanguage = document.querySelector('input[name="language"]:checked').value;
            if (activeLanguage === 'en') {
              editor.root.innerHTML = blogData.content.en;
            }
          } else {
            showAlert('error', result.message || 'Erreur lors de la traduction du contenu.');
          }
        } catch (error) {
          console.error('Erreur de connexion lors de la traduction du contenu :', error);
          showAlert('error', 'Erreur de connexion au serveur lors de la traduction du contenu.');
        } finally {
          if (loaderModal) {
            loaderModal.classList.add('hidden');
            document.body.classList.remove('noscroll');
            overlay && overlay.classList.add('hidden');
          }
        }
      });
    }

    // --- Traduction du titre et de la description (bouton translateMetaBtn) ---
    const translateMetaBtn = document.getElementById('translateMetaBtn');
    if (translateMetaBtn) {
      translateMetaBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        // Afficher la modal de chargement
        if (loaderModal) {
          loaderModal.classList.remove('hidden');
          document.body.classList.add('noscroll');
          overlay && overlay.classList.remove('hidden');
        }
        // Pour la traduction meta, on récupère directement le contenu français des inputs
        const titleFr = titleFrInput ? titleFrInput.value : '';
        const descriptionFr = descFrInput ? descFrInput.value : '';

        if (!titleFr || !descriptionFr) {
          showAlert('error', 'Le titre et la description en français sont requis pour la traduction.');
          if (loaderModal) {
            loaderModal.classList.add('hidden');
            document.body.classList.remove('noscroll');
            overlay && overlay.classList.add('hidden');
          }
          return;
        }

        try {
          const response = await fetch('/api/v1/blog/translate-meta', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ titleFr, descriptionFr }),
          });
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText);
          }
          const result = await response.json();
          if (result.status === 'success') {
            // Mise à jour dans blogData
            // console.log(result.data.title);

            blogData.title['en'] = result.data.title;
            blogData.description['en'] = result.data.description;

            console.log(blogData.title['en']);

            // Si la langue active est l'anglais, mettre à jour les inputs visibles
            const activeLanguage = document.querySelector('input[name="language"]:checked')?.value;
            if (activeLanguage === 'en') {
              if (titleEnInput) titleEnInput.value = result.data.title;
              if (descEnInput) descEnInput.value = result.data.description;
            }
            showAlert('success', 'Titre et description traduits en anglais !');
          } else {
            showAlert('error', result.message || 'Erreur lors de la traduction meta.');
          }
        } catch (error) {
          console.error('Erreur de connexion lors de la traduction meta :', error);
          showAlert('error', 'Erreur de connexion au serveur lors de la traduction meta.');
        } finally {
          if (loaderModal) {
            loaderModal.classList.add('hidden');
            document.body.classList.remove('noscroll');
            overlay && overlay.classList.add('hidden');
          }
        }
      });
    } else {
      console.error("translateMetaBtn n'est pas trouvé dans le DOM.");
    }

    // === Soumission du formulaire ===
    if (editBlogForm) {
      editBlogForm.addEventListener('submit', async function (e) {
        e.preventDefault();

        // Mettre à jour content/titre/description pour la langue active
        if (activeLang === 'fr') {
          blogData.title.fr = titleFrInput?.value || '';
          blogData.description.fr = descFrInput?.value || '';
          blogData.content.fr = editor.root.innerHTML;
        } else {
          blogData.title.en = titleEnInput?.value || '';
          blogData.description.en = descEnInput?.value || '';
          blogData.content.en = editor.root.innerHTML;
        }
        // Vérifier si le contenu en fr/en est vide
        if (!blogData.content.en) blogData.content.en = blogData.content.fr;
        if (!blogData.content.fr) blogData.content.fr = blogData.content.en;

        // Mettre à jour les champs cachés si besoin
        if (contentHiddenFr) contentHiddenFr.value = blogData.content.fr;
        if (contentHiddenEn) contentHiddenEn.value = blogData.content.en;

        // === Récupérer tags & catégories en lisant les <li> existants ===
        // Catégories
        let categoriesArr = [];
        if (categoriesList) {
          const catEls = categoriesList.querySelectorAll('li.blog__categories--item');
          catEls.forEach((li) => {
            const text = li.textContent.replace('x', '').trim();
            if (text) categoriesArr.push(text);
          });
        }
        // Tags
        let tagsArr = [];
        if (tagsList) {
          const tagEls = tagsList.querySelectorAll('li.blog__tags--item');
          tagEls.forEach((li) => {
            const text = li.textContent.replace('x', '').trim();
            if (text) tagsArr.push(text);
          });
        }

        // On place ces tableaux dans blogData
        blogData.categories = categoriesArr;
        blogData.tags = tagsArr;

        // === Préparer FormData (incluant l'image de couverture) ===
        const formData = new FormData();
        formData.append('slug', document.getElementById('slug')?.value || '');
        formData.append('title[fr]', blogData.title.fr);
        formData.append('title[en]', blogData.title.en);
        formData.append('description[fr]', blogData.description.fr);
        formData.append('description[en]', blogData.description.en);
        formData.append('content[fr]', blogData.content.fr);
        formData.append('content[en]', blogData.content.en);

        // Ajouter les tags / catégories dans le FormData
        // On utilise un format "tags[]" pour qu'on les récupère en tableau côté serveur
        blogData.categories.forEach((cat) => {
          formData.append('categories[]', cat);
        });
        blogData.tags.forEach((tg) => {
          formData.append('tags[]', tg);
        });

        formData.append('status', document.getElementById('statusSelect')?.value || '');
        formData.append('createdAt', publicationDateInput?.value || '');

        // Image de couverture
        const imageFile = document.getElementById('coverImageFile')?.files[0];
        if (imageFile) {
          formData.append('coverImage', imageFile);
        }

        // === Envoi de la requête ===
        try {
          const response = await fetch(editBlogForm.getAttribute('action'), {
            method: 'POST',
            body: formData,
          });
          const result = await response.json();
          if (result.status === 'success') {
            showAlert('success', 'Article de blog mis à jour avec succès !');
            // Si on est en création et qu'il n'y a pas de blogId dans l'URL => rediriger
            if (
              window.location.pathname === '/admin/blog/new' ||
              (window.location.pathname === '/fr/admin/blog/new' && !window.location.search.includes('blogId'))
            ) {
              setTimeout(() => {
                window.location.href = `/admin/blog/new?blogId=${result.data._id}`;
              }, 1500);
            }
          } else {
            showAlert('error', result.message || 'Erreur lors de la mise à jour.');
          }
        } catch (error) {
          console.error('Erreur lors de la requête:', error);
          showAlert('error', 'Erreur de connexion au serveur.');
        }
      });
    }

    const deleteBlogBtn = document.getElementById('deleteBlogBtn');
    if (deleteBlogBtn) {
      deleteBlogBtn.addEventListener('click', async function () {
        const blogId = deleteBlogBtn.getAttribute('data-blog-id');
        if (!blogId) {
          showAlert('error', "ID de l'article introuvable.");
          return;
        }
        if (!confirm('Êtes-vous sûr de vouloir supprimer cet article de blog ?')) return;
        try {
          const response = await fetch(`/api/v1/blog/${blogId}`, {
            method: 'DELETE',
          });
          const result = await response.json();
          if (result.status === 'success') {
            showAlert('success', 'Article de blog supprimé avec succès !');
            setTimeout(() => (window.location.href = '/fr/admin/blog'), 1500);
          } else {
            showAlert('error', result.message || 'Erreur lors de la suppression.');
          }
        } catch (error) {
          console.error('Erreur lors de la suppression :', error);
          showAlert('error', 'Erreur de connexion au serveur.');
        }
      });
    }

    // — Bouton de preview —
    const overlayPreview = document.getElementById('previewOverlay');
    const previewBtn = document.getElementById('previewBtn');
    const previewModal = document.getElementById('previewModal');
    const previewTitle = document.getElementById('previewTitle');
    // const previewDescription = document.getElementById('previewDescription');
    const previewContent = document.getElementById('previewContent');
    const closeBtn = document.querySelector('.popup__close');
    const btnLangFR = document.getElementById('btnLangFR');
    const btnLangEN = document.getElementById('btnLangEN');

    if (previewBtn && previewModal && previewTitle && previewContent && overlayPreview) {
      const setContent = (lang) => {
        previewTitle.textContent = blogData.title?.[lang] || 'Titre manquant';
        // previewDescription.textContent = blogData.description?.[lang] || 'Description manquante';
        previewContent.innerHTML = blogData.content?.[lang] || '<p>Contenu vide</p>';
      };

      previewBtn.addEventListener('click', () => {
        // Mettre à jour les données du blog selon la langue active
        if (activeLang === 'fr') {
          blogData.title.fr = titleFrInput?.value || '';
          blogData.description.fr = descFrInput?.value || '';
          blogData.content.fr = editor.root.innerHTML;
        } else {
          blogData.title.en = titleEnInput?.value || '';
          blogData.description.en = descEnInput?.value || '';
          blogData.content.en = editor.root.innerHTML;
        }

        // Remplissage par fallback si nécessaire
        if (!blogData.content.en) blogData.content.en = blogData.content.fr;
        if (!blogData.content.fr) blogData.content.fr = blogData.content.en;
        if (!blogData.title.en) blogData.title.en = blogData.title.fr;
        if (!blogData.title.fr) blogData.title.fr = blogData.title.en;
        if (!blogData.description.en) blogData.description.en = blogData.description.fr;
        if (!blogData.description.fr) blogData.description.fr = blogData.description.en;

        // Affichage initial en français par défaut
        previewTitle.textContent = blogData.title.fr;
        // previewDescription.textContent = blogData.description.fr;
        previewContent.innerHTML = blogData.content.fr;

        previewModal.classList.remove('hidden');
        overlayPreview.classList.remove('hidden');
        document.body.classList.add('noscroll');
      });

      const closePreview = () => {
        previewModal.classList.add('hidden');
        overlayPreview.classList.add('hidden');
        document.body.classList.remove('noscroll');
      };

      closeBtn.addEventListener('click', closePreview);
      overlayPreview.addEventListener('click', closePreview);

      btnLangFR?.addEventListener('click', () => setContent('fr'));
      btnLangEN?.addEventListener('click', () => setContent('en'));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closePreview();
      });
    }

    // — utilitaires DOM rapides —
    const $ = (s) => document.querySelector(s);
    const $$ = (s) => [...document.querySelectorAll(s)];

    const quill = window.quill || ($('#editor') && $('#editor').__quill);
    if (!quill) return console.error('Quill non trouvé — initialisez‑le puis exposez‑le via window.quill');

    const titleInput = $('#title');
    const descriptionInput = $('#description');

    // règles & helpers -----------------------------------------------------
    const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

    function setBar(li, current, max, thresholds) {
      const bar = li.querySelector('.progress-bar');
      const pct = clamp((current / max) * 100, 0, 100);
      bar.style.width = pct + '%';
      // couleur
      if (current > thresholds.high) {
        bar.style.background = '#e74c3c'; // rouge
        li.classList.add('fail');
        li.classList.remove('ok');
      } else if (current >= thresholds.low) {
        bar.style.background = '#27ae60'; // vert
        li.classList.remove('fail');
        li.classList.add('ok');
      } else {
        bar.style.background = '#f39c12'; // orange
        li.classList.add('fail');
        li.classList.remove('ok');
      }
    }

    const checks = {
      title: {
        li: $('[data-check="title"]'),
        update() {
          const len = titleInput.value.trim().length;
          setBar(this.li, len, 60, { low: 30, high: 60 });
          this.li.querySelector('.details').textContent = `${len} / 60`;
        },
      },
      description: {
        li: $('[data-check="description"]'),
        update() {
          const len = descriptionInput.value.trim().length;
          setBar(this.li, len, 170, { low: 130, high: 170 });
          this.li.querySelector('.details').textContent = `${len}`;
        },
      },
      length: {
        li: $('[data-check="length"]'),
        update() {
          const words = quill.getText().trim().split(/\s+/).filter(Boolean).length;
          const barMax = 1700;
          setBar(this.li, words, barMax, { low: 1000, high: 1700 });
          this.li.querySelector('.details').textContent = `${words} mots`;
        },
      },
      image: {
        li: $('[data-check="image"]'),
        update() {
          const count = (quill.root.innerHTML.match(/<img\b[^>]*>/gi) || []).length;
          const ok = count >= 1;
          this.li.classList.toggle('ok', ok);
          this.li.classList.toggle('fail', !ok);
          this.li.querySelector('.details').textContent = `${count}`;
        },
      },
      alt: {
        li: $('[data-check="alt"]'),
        update() {
          const imgs = [...quill.root.querySelectorAll('img')];
          const total = imgs.length;
          const withAlt = imgs.filter((img) => {
            const a = img.getAttribute('alt');
            return a && a.trim().length > 0;
          }).length;
          const ok = total > 0 ? withAlt === total : false;
          this.li.classList.toggle('ok', ok);
          this.li.classList.toggle('fail', !ok);
          this.li.querySelector('.details').textContent = `${withAlt}/${total}`;
        },
      },
      paragraphs: {
        li: $('[data-check="paragraphs"]'),
        update() {
          const paragraphs = quill.getText().split(/\n+/).filter(Boolean);
          const longest = Math.max(0, ...paragraphs.map((p) => p.trim().length));
          const ok = longest <= 400;
          this.li.classList.toggle('ok', ok);
          this.li.classList.toggle('fail', !ok);
          this.li.querySelector('.details').textContent = `max ${longest}`;
        },
      },
      headings: {
        li: $('[data-check="headings"]'),
        update() {
          const matches = quill.root.innerHTML.match(/<h([2-6])\b[^>]*>/gi) || [];
          const levels = matches.map((m) => parseInt(m.match(/<h([2-6])/i)[1]));
          let ok = true;
          for (let i = 1; i < levels.length; i++) {
            if (levels[i] - levels[i - 1] > 1) {
              ok = false;
              break;
            }
          }
          this.li.classList.toggle('ok', ok);
          this.li.classList.toggle('fail', !ok);
          this.li.querySelector('.details').textContent = levels.join(' › ') || '—';
        },
      },
    };

    const refresh = () => Object.values(checks).forEach((c) => c.update());

    ['input', 'change'].forEach((evt) => {
      titleInput.addEventListener(evt, refresh);
      descriptionInput.addEventListener(evt, refresh);
    });
    quill.on('text-change', refresh);
    refresh();
  });
}
